"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LangSetting = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _vueJsonView = require("vue-json-view");

var _dec, _dec2, _class, _class2, _descriptor, _descriptor2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LangSetting = (_dec = (0, _vuePropertyDecorator.Model)('change'), _dec2 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(LangSetting, _Vue);

  var _super = _createSuper(LangSetting);

  function LangSetting() {
    var _this;

    (0, _classCallCheck2.default)(this, LangSetting);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "value", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "propertyList", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    _this.visible = false;
    return _this;
  }

  (0, _createClass2.default)(LangSetting, [{
    key: "showModal",
    value: function showModal() {
      this.visible = true;
    }
  }, {
    key: "onOk",
    value: function () {
      var _onOk = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(values) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit('change', values);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onOk(_x) {
        return _onOk.apply(this, arguments);
      }

      return onOk;
    }()
  }, {
    key: "render",
    value: function render(h) {
      var _this2 = this;

      var propertyList = this.propertyList,
          _this$value = this.value,
          value = _this$value === void 0 ? {} : _this$value,
          showModal = this.showModal,
          onOk = this.onOk;
      var form = JSON.stringify({
        tag: 'mh-form',
        layout: 'vertical',
        name: '语言设置',
        enName: '语言设置',
        children: propertyList
      });
      var tags = propertyList.map(function (property, i) {
        var val = _vueJsonView.Utils.getDataByName(value, property.name);

        if (val) {
          var onClose = function onClose() {
            var newValue = _vueJsonView.Utils.setDataByObj(value, (0, _defineProperty2.default)({}, property.name, undefined));

            _this2.$emit('change', newValue);
          };

          return h("a-tag", {
            "attrs": {
              "closable": true,
              "visible": true
            },
            "on": {
              "close": onClose
            },
            "style": "margin-bottom: 8px; max-width: 100%;word-break: break-all; white-space: normal;"
          }, [property.label, ": ", val]);
        }
      });
      return h("span", [tags, h("a-button", {
        "on": {
          "click": function click() {
            return showModal();
          }
        },
        "attrs": {
          "block": true
        }
      }, ["\u8BED\u8A00\u8BBE\u7F6E"]), h("mh-form-modal", {
        "attrs": {
          "json": form,
          "data": value,
          "handleSubmit": onOk
        },
        "model": {
          value: _this2.visible,
          callback: function callback($$v) {
            _this2.visible = $$v;
          }
        }
      })]);
    }
  }]);
  return LangSetting;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "value", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "propertyList", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.LangSetting = LangSetting;